import Page from "components/Page";
import { SurveyTemplatesListProps } from "./SurveyTemplates.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const SurveyTemplatesList = lazyWithRetry(() => import("./SurveyTemplatesList"));

export default (props: SurveyTemplatesListProps) => (
  <Page>
    <SurveyTemplatesList {...props} />
  </Page>
);
